// Quick BIST symbols for autocomplete
export const BIST_QUICK = [
  "AKBNK","GARAN","ISCTR","YKBNK","HALKB","VAKBN","THYAO","PGSUS","BIMAS","MGROS",
  "TUPRS","EREGL","KRDMD","KOZAL","KOZAA","SISE","ARCLK","TCELL","TTKOM","SAHOL",
  "KCHOL","ASELS","PETKM","SASA","TOASO","FROTO","TTRAK","ENKAI","AKSEN","EKGYO",
  "ALARK","ASTOR","AEFES","CCOLA","ULKER","BRISA","DOAS","OTKAR","TAVHL","SOKM",
  "KONTR","HEKTS","LOGO","MAVI","VESTL","TSKB","AKFYE","ENJSA","ODAS","DOHOL",
];
